module.exports = __webpack_public_path__ + "media/theme/icon__payment__discover-a98b476d.svg";